import { Component, OnInit } from "@angular/core";
import { StatusService } from "./status.service";
import { NotifierService } from "src/app/_services/notifier.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-master-status-overview",
  templateUrl: "./master_status.component.html",
  styleUrls: ["./master_status.component.css"],
})
export class MasterStatusOverviewComponent implements OnInit {
  masterStatusList: any[] = [];

  showInspectModal = false;
  showTriggerModal = false;
  showDetailModal = false;
  selectedAccountId = "";

  headers = [
    { name: "GUID", id: "guid" },
    { name: "Account ID", id: "master_account_id" },
    { name: "Stage", id: "stage" },
    { name: "Sub Stage", id: "sub_stage" },
    { name: "Status", id: "status" },
    { name: "Duration (s)", id: "duration_seconds" },
    { name: "Record Count", id: "record_count" },
    { name: "Last Updated", id: "last_updated" },
  ];

  constructor(
    private statusService: StatusService,
    public notifier: NotifierService,
    public navigate: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.load();
  }

  load() {
    this.notifier.loading(true);
    this.statusService.getLatestStatus().subscribe({
      next: (res) => {
        if (res?.status === "1" && res?.data?.processes) {
          this.masterStatusList = res.data.processes;
        } else {
          this.notifier.alert("Info", "", res.msg, "info", 5000);
        }
        this.notifier.loading(false);
      },
      error: (err) => {
        console.error("Error fetching status:", err);
        this.notifier.loading(false);
      },
    });
    console.log("master details", this.masterStatusList);
  }

  getStatusClass(status: string): string {
    switch (status) {
      case "SUCCESS":
        return "text-success fw-bold";
      case "FAILED":
        return "text-danger fw-bold";
      case "IN_PROGRESS":
        return "text-warning fw-bold";
      default:
        return "text-muted";
    }
  }
  master: any;
  viewDetails(guid: string): void {
    this.navigate.navigate(
      ["stagedetails"], 
      {
        relativeTo: this.route, 
        queryParams: { guid },
      }
    );
  }

  closeDetailModal() {
    this.showDetailModal = false;
    this.selectedAccountId = "";
  }

  closeTriggerModal() {
    this.showTriggerModal = false;
    this.load();
  }

  openInspectModal() {
    this.showInspectModal = true;
  }

  closeInspectModal() {
    this.showInspectModal = false;
  }
}
